import { Permission, PERMISSIONS } from '../models/permission.model';

const PERMISSIONS_SET = new Set<Permission>(PERMISSIONS);

export function toPermissions(raw: string[]): Permission[] {
  return raw.filter((p): p is Permission => PERMISSIONS_SET.has(p as Permission));
}
